// extracted by mini-css-extract-plugin
export default {"wholesale":"wholesale_wholesale__RlzNb"};